import React from 'react';

const ErrorPage = () => {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-animation">
          <div className="error-number">4</div>
          <div className="error-circle">
            <div className="error-face">
              <div className="error-eyes">
                <div className="error-eye"></div>
                <div className="error-eye"></div>
              </div>
              <div className="error-mouth"></div>
            </div>
          </div>
          <div className="error-number">4</div>
        </div>
        
        <div className="error-content">
          <h1 className="error-title">404 Not Found</h1>
          <p className="error-message">
            Oops! The page you're looking for seems to have wandered off into the digital void.
          </p>
          <p className="error-submessage">
            Don't worry, even the best explorers sometimes take a wrong turn.
          </p>
          
          <div className="error-actions">
            <button className="error-btn primary" onClick={handleGoHome}>
              <span className="btn-icon">🏠</span>
              Go Home
            </button>
            <button className="error-btn secondary" onClick={handleGoBack}>
              <span className="btn-icon">←</span>
              Go Back
            </button>
          </div>
        </div>
        <div className="error-decorations">
          <div className="floating-shape shape-1"></div>
          <div className="floating-shape shape-2"></div>
          <div className="floating-shape shape-3"></div>
          <div className="floating-shape shape-4"></div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;